module.exports = __webpack_public_path__ + "static/img/完成@3x.4332c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dialog/完成@3x.png
// module id = 220
// module chunks = 126 363 364